module.exports = __webpack_public_path__ + "ptc_momoro_T1.b0ba8f0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_T1.jpg
// module id = BlBy
// module chunks = 0